import { FC, useState } from "react";
import { Color, ColorResult, SketchPicker } from "react-color";

interface ColorPickerProps {
    color: Color;
    onChange?: (color: string) => void;
}

export const ColorPicker: FC<ColorPickerProps> = ({ color, onChange }) => {
    const [currentColor, setCurrentColor] = useState<string>(color.toString());
    const [showPicker, setShowPicker] = useState(false);

    const onChangeComplete = (result: ColorResult) => {
        const colorString = result.hex;
        setCurrentColor(colorString);
        onChange?.(colorString);
    };

    return (
        <div>
            <div
                className="w-10 h-10 rounded"
                style={{ backgroundColor: currentColor }}
                onClick={() => setShowPicker(true)}
            />
            {showPicker && <div className="absolute z-10">
                <div className="fixed top-0 left-0 bottom-0 right-0" onClick={() => setShowPicker(false)}/>
                <SketchPicker color={currentColor} onChange={onChangeComplete} />
            </div>}
        </div>
    );
}